import { useIntl } from 'react-intl'

export const useRequiredRule = ({ rule, label, name, messageId = 'yup_mixed_required' }) => {
	const { formatMessage } = useIntl()

	if (rule) {
		return typeof rule === 'boolean'
			? formatMessage({ id: messageId }, { path: typeof label === 'string' ? label : name })
			: rule
	} else {
		return false
	}
}
